/* eslint-disable @typescript-eslint/no-explicit-any */
import { startAnalytics } from '@elc-online/up-analytics';

const settings = window.utag_cfg_ovrd?.settings ?? {};

const analyticsSettings = {
  profile: settings.tealiumProfile || '',
  env: /^(dev|prod)$/.test(settings.tealiumEnv) ? settings.tealiumEnv : 'qa',
  url: settings.tealiumUrl || 'tags.tiqcdn.com'
};

startAnalytics({ analytics: analyticsSettings });
